// extracted by mini-css-extract-plugin
export default {"melodyVideo":"iK-z","isFullWidth":"jK-z","landingPageVideo":"kK-z","play":"lK-z","iframeVideo":"mK-z","playHidden":"nK-z","fullwidth":"oK-z"};